import { Amplify } from 'aws-amplify';

// Get redirect URLs - use current origin for local dev, env var for production
// For local development: uses window.location.origin (http://localhost:3000/)
// For production: uses REACT_APP_OAUTH_REDIRECT_SIGN_IN from environment variables
const getRedirectUrls = () => {
  // In browser, always use current origin for local development
  // This ensures it works locally without needing to match Cognito exactly
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin + '/';
    
    // If we're on localhost, use it (for local dev)
    if (currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')) {
      return [currentOrigin];
    }
    
    // For production (not localhost), use environment variable if set
    // Otherwise fall back to current origin
    const envRedirect = process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN;
    return envRedirect ? [envRedirect] : [currentOrigin];
  }
  
  // Fallback for SSR or build time
  return [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_IN || 'http://localhost:3000/'];
};

const redirectSignIn = getRedirectUrls();
const redirectSignOut = (() => {
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin + '/';
    if (currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')) {
      return [currentOrigin];
    }
  }
  return process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT 
    ? [process.env.REACT_APP_OAUTH_REDIRECT_SIGN_OUT]
    : redirectSignIn;
})();

// Validate required environment variables
const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

// Log configuration status (helpful during development)
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  console.log('🔍 Amplify Configuration Check:');
  console.log('   REACT_APP_COGNITO_USER_POOL_ID:', userPoolId ? '✅ Set' : '❌ Missing');
  console.log('   REACT_APP_COGNITO_CLIENT_ID:', clientId ? '✅ Set' : '❌ Missing');
  console.log('   REACT_APP_COGNITO_DOMAIN:', cognitoDomain ? '✅ Set' : '❌ Missing');
  console.log('   REACT_APP_API_URL:', process.env.REACT_APP_API_URL || '❌ Missing');
}

if (!userPoolId || !clientId) {
  const errorMsg = '❌ Cognito configuration is missing! Environment variables must be set in Amplify Console and a new build must be triggered.';
  console.error(errorMsg);
  // Don't throw error, just log it so the app can still load
}

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: userPoolId || '',
      userPoolClientId: clientId || '',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        oauth: {
          domain: cognitoDomain || '',
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: redirectSignIn,
          redirectSignOut: redirectSignOut,
          responseType: 'code',
          providers: ['Google']
        }
      }
    }
  }
};

// Only configure if we have the required values
if (userPoolId && clientId) {
  try {
    Amplify.configure(amplifyConfig);
    if (process.env.NODE_ENV !== 'production') {
      console.log('✅ Amplify configured successfully');
    }
  } catch (error) {
    console.error('❌ Error configuring Amplify:', error);
  }
} else {
  console.error('❌ Cannot configure Amplify - missing Cognito credentials');
  console.error('   Please ensure environment variables are set in Amplify Console and a new build is triggered');
}

export default amplifyConfig;

